import React from 'react';
import PropTypes from 'prop-types';
import { Close } from 'pcln-icons';
import { IconButton } from '../IconButton';
const propTypes = {
    onClick: PropTypes.func,
    size: PropTypes.number,
    title: PropTypes.string,
};
const CloseButton = (props) => (React.createElement(IconButton, Object.assign({}, props, { icon: React.createElement(Close, { size: props.size }) })));
CloseButton.defaultProps = {
    size: 24,
    title: 'close',
};
CloseButton.propTypes = {};
CloseButton.displayName = 'CloseButton';
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map